module.exports = __webpack_public_path__ + "img/depmap_svg_V3.de80a2ec.svg";